import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { getUserRoles, hasAnyRole } from '../utils/roles.util';

const ROUTE_ROLES: Record<string, string[]> = {
  'get-addons':                ['cx', 'admin'],
  'get-user':                  ['cx', 'admin'],
  'unblock-user':              ['cx', 'admin'],
  'update-contact':            ['cx', 'admin'],
  'crc-consult':               ['analytic', 'admin', 'cx'],
  'suppressed-email':          ['cx', 'admin', 'dev'],
  'create-user':               ['admin'],
  'first-login':               ['admin', 'cx'],
  'certificados':              ['cx', 'admin'],
  'infraestructura-seguimiento': ['admin', 'infraestructura'],
  'chat-boris':                ['comercial', 'admin', 'cdt'],
  'inventario':                ['admin', 'infraestructura'],
  'vinculador-pagador-pm':     ['admin', 'comercial'],
};

@Injectable({
  providedIn: 'root'
})
export class RolGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) { }

  private getUserRoles(): string[] {
    return getUserRoles();
  }

  canActivate(): boolean {
    const userRoles = this.getUserRoles();
    if (hasAnyRole(userRoles, environment.allowedRoles)) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    const userRoles = this.getUserRoles();
    if (!hasAnyRole(userRoles, environment.allowedRoles)) {
      this.router.navigate(['/login']);
      return false;
    }

    const path = route.routeConfig?.path ?? '';
    const allowedRoles = ROUTE_ROLES[path];

    if (!allowedRoles) {
      return true;
    }

    if (hasAnyRole(userRoles, allowedRoles)) {
      return true;
    }

    this.router.navigate(['/pages']);
    return false;
  }
}
